import React, { createContext, useState, useEffect, ReactNode } from 'react'
import { useIsTabletOrMobile } from 'lib/shared/hooks/responsive'
import { useIsXxS } from 'hooks/responsive'
import { useStoreView } from 'hooks/useStoreView'
import { Search } from 'components/Layout/components/Header/components/Search' // TODO: Refactor
import { AccountLinks } from 'components/Layout/components/Header/components/AccountLinks' // TODO: Refactor
import { ItemsRender } from './components/ItemsRender'
import { Container } from './components/Styled'
import { FadeIn } from 'lib/ui/components'
import { sofiaMenu, livBriteMenu } from './data'

export interface MenuItem {
  id: string
  parentId?: string
  label: string
  url: string
  image?: string
  icon?: string
  items?: MenuItem[]
  render?: 'text' | 'text-icon' | 'image' // default to 'text' on implementation
}

export const MenuDropdown = () => {
  const isMobile = useIsXxS()
  const isTablet = useIsTabletOrMobile()
  const { menuItems, setMenuItems } = useSmallMenu()
  const { isSofiaAndGrace } = useStoreView()
  const menuParent: string = menuItems?.parent
  const menu = isSofiaAndGrace ? sofiaMenu : livBriteMenu

  function filterMenu (menuParent: string, menu: MenuItem[]): Record<string, any> {
    return menu.reduce((a: any, menuItem: Record<string, any>) => {
      if (a) return a
      if (menuItem.id === menuParent) return menuItem
      if (menuItem.items) return filterMenu(menuParent, menuItem.items)
      return false
    }, null)
  }

  const handleBack = () => {
    const previusItems = filterMenu(menuParent, menu)
    const previusMenuItems = previusItems?.items
    const previusParentId = previusItems?.parentId ?? 'root'
    setMenuItems({
      items: previusMenuItems,
      parent: previusParentId
    })
  }

  if (menuItems?.items) {
    return (
      <FadeIn>
        <Container>
          <ul>
            <ItemsRender
              items={menuItems?.items}
            />
            {menuParent && (
              <li
                onClick={handleBack}
              >
                <span className='back'>Back</span>
              </li>
            )}
          </ul>
        </Container>
      </FadeIn>
    )
  } else {
    return (
      <FadeIn>
        <Container>
          <ul>
            <ItemsRender
              items={menu}
            />
          </ul>
          {isTablet && (
            <AccountLinks />
          )}
          {isMobile && (
            <Search />
          )}
        </Container>
      </FadeIn>
    )
  }
}

interface SmallMenuContextInterface {
  menuItems?: any
  setMenuItems: (items: any, parent?: any) => void
}

export const SmallMenuContext = createContext<SmallMenuContextInterface>({
  menuItems: {},
  setMenuItems: () => undefined
})

interface Props {
  children?: ReactNode
  isMenuVisible?: boolean
}

export const SmallMenuProvider: React.FC<Props> = ({ children, isMenuVisible }) => {
  const [menuItems, setMenuItems] = useState()

  useEffect(() => {
    setMenuItems(undefined)
  }, [isMenuVisible])

  return (
    <SmallMenuContext.Provider
      value={{
        menuItems,
        setMenuItems
      }}
    >
      {children}
    </SmallMenuContext.Provider>
  )
}

export const useSmallMenu = () => {
  const context = React.useContext(SmallMenuContext)
  if (context === undefined) {
    throw new Error('useSmallMenu must be used within a SmallMenuProvider')
  }
  return context
}
